module.exports = __webpack_public_path__ + "static/media/10-2.d68daa0a.mp3";